import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { logger } from "common/utilities/logger";
import { fetchCollections, updateCollectionFailure, updateCollectionSuccess } from "domains/collection/actions";
import type { UpdateCollectionAction } from "domains/collection/actionTypes";
import { CollectionType } from "domains/collection/types/collectionType";
import { activateModal } from "domains/modal/actions";
import { router } from "router/router";

export function* updateCollectionSaga({ payload }: UpdateCollectionAction) {
  try {
    const { co_brands, ...rest } = payload;
    const body = { ...rest, co_brand_ids: co_brands.map(({ id }) => id) };
    yield apiFetch(`collection/${payload.id}/edit`, { body, method: "PUT" });
    yield router.navigate(`/collection/${payload.id}`);
    yield put(updateCollectionSuccess(payload));
    yield put(fetchCollections(CollectionType.Editable));
  } catch (error) {
    logger.error(`[updateCollectionSaga] Failed to update collection with ID '${payload.id}'`, error);
    yield put(updateCollectionFailure(payload.id));
    yield put(
      activateModal({
        id: "Error",
        params: { localisedMessageKey: "app.create.collection.modal.error_while_saving" },
      }),
    );
  }
}
